import React, { FC } from "react";
import { Navigate } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_ME } from "../graphql/queries";
import { MeData } from "../models/types";

interface Props {
    children: any;
}

const isSeepian = (me?: MeData["me"]) =>
    me !== undefined && Number(me.organization?.id) === 1;

const SeepianOnlyComponentImplementation: FC<Props> = ({ children }) => {
    const { data: { me } = {} } = useQuery<MeData>(GET_ME, {
        fetchPolicy: "cache-first"
    });

    if (!isSeepian(me)) {
        return null;
    }

    return <>{children}</>;
};

export const SeepianOnlyComponent = React.memo(
    SeepianOnlyComponentImplementation
);

export const SeepianOnlyRoute: FC<Props> = ({ children }) => {
    const { data: { me } = {}, loading } = useQuery<MeData>(GET_ME, {
        fetchPolicy: "cache-first"
    });

    if (loading) {
        return null;
    }

    if (!isSeepian(me)) {
        return <Navigate to="/products" />;
    }

    return <>{children}</>;
};
